import type { ReleaseAudience } from '../../../lib/releaseFrontmatterSchema';

// Who an announcement or a campaign is for. One vocabulary for both, the same
// as the notification center's (modules, countries, team leaders / members).
export type Audience = ReleaseAudience;

// The facts about the current user that audiences are matched against.
export type Viewer = {
  tenantId: string;
  isRATenant: boolean;
  countryCode: string;
  moduleIds: readonly string[];
  isTeamLeader: boolean;
  accountCreatedDay?: string | null;
};

export const isInAudience = (audience: Audience, viewer: Viewer): boolean => {
  const tenantOk =
    audience.tenants === 'all' ||
    (audience.tenants === 'ra'
      ? viewer.isRATenant
      : audience.tenants.includes(viewer.tenantId));
  const countryOk =
    audience.countries == null ||
    audience.countries.includes(viewer.countryCode);
  const moduleOk =
    audience.modules == null ||
    audience.modules.some(module => viewer.moduleIds.includes(module));
  const recipientsOk =
    audience.recipients === 'everyone' ||
    (audience.recipients === 'team_leaders'
      ? viewer.isTeamLeader
      : !viewer.isTeamLeader);
  return tenantOk && countryOk && moduleOk && recipientsOk;
};
